module.exports = __webpack_public_path__ + "img/symbol_5.76db6c8a.png";